module.exports = require("await-exec");